module.exports = __webpack_public_path__ + "img/QuanspireLogoBlue.1f0d6bda.svg";